import { render, staticRenderFns } from "./AddMenuGroup.vue?vue&type=template&id=0f28f338&scoped=true"
import script from "./AddMenuGroup.vue?vue&type=script&lang=js"
export * from "./AddMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./AddMenuGroup.vue?vue&type=style&index=0&id=0f28f338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f28f338",
  null
  
)

export default component.exports